var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('Navbar'),_c('Modals',{ref:"modal2"}),_c('LoadingPage',{ref:"loading_component"}),_c('v-row',[_c('v-col',{staticStyle:{"padding-top":"0px"},attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }